import { isNumber, NunjucksEnvCallbacks, wcFoundationClasses } from '@bonusmap/shared_ui/library';
import type { User } from "@bonusmap/api-types";
export abstract class BaseWebComponent extends wcFoundationClasses.templating {
    get shadowOptionImplementation(): "open" | "closed" | "none" {
        return "none"; // Override in subclasses if needed
    }
    // =============================
    get user(): User {
        return window.user; // Assuming window.user is set globally
    }
    get adminNotImpersonating(): boolean {
        return  (this.isAdmin && !this.user?.impersonation && this.user?.organization_id == 0);
    }
    
    protected _nunjucksEnvCallbacks!: NunjucksEnvCallbacks;
    get nunjucksEnvCallbacks(): NunjucksEnvCallbacks {
        if (!this._nunjucksEnvCallbacks) {
            this._nunjucksEnvCallbacks = {
                globals: {
                    isAdmin: this.isAdmin,
                    isEdit: this.isEdit,
                    organizationId: this.organizationId,
                    organizationName: this.organizationName,
                    loggedOrganizationId: this.loggedOrganizationId,
                    loggedOrganizationName: this.loggedOrganizationName,
                    adminNotImpersonating: this.adminNotImpersonating,
                    
                },
                filters: {
                    // Add custom filters if needed
                    dateFormat: (date: Date|string) => {
                        const d = new Date(date);
                        if(isNaN(d.getTime())) {
                            return '';
                        }
                        return d.toLocaleDateString('it-IT');
                    } ,
                    numberFormat: (num: number|string) => {
                        const n = Number(num);
                        if(isNaN(n)) {
                            return '';
                        }
                        return n.toLocaleString('it-IT');
                    },
                    tojson: (obj: any) => {
                        return JSON.stringify(obj);
                    },
                    orgName: (id:any) => {
                        if (id === null || id === undefined) return 'N/A';
                        if(isNumber(id)) id = Number(id);
                        if (id === 0) return 'Tutte le organizzazioni'; 
                        if(window.organizationsList && Array.isArray(window.organizationsList)) {
                            const org = window.organizationsList.find(o => o.id === id);
                            return org ? org.name : `Organizzazione #${id}`;
                        }
                        return `Organizzazione #${id}`;
                    }

                }
            };
        }
        else {
            console.log("Using cached _nunjucksEnvCallbacks");
        }
        return this._nunjucksEnvCallbacks;
    }
    get organizationId(): number | null {
        if (this.user) {
            if (this.isAdmin && this.user.impersonation) {
                return Number(this.user.impersonation.id);
            }
            return this.user.organization_id ?? null;
        }
        return null;
    }
    get organizationName(): string | null {
        if (this.organizationId) {
            if (this.isAdmin && this.user.impersonation) {
                return this.user.impersonation.name;
            }
            return this.user.organization_name ?? null;
        }
        return null;
    }
    get isAdmin(): boolean {
        return this.user?.role === 'admin' || this.user?.role === 'superadmin';
    }
    get isSuperAdmin(): boolean {
        return this.user?.superAdmin === true;
    }
    get isEdit(): boolean {
        return this.isAdmin || this.user?.role === 'edit';
    }
    get loggedOrganizationId(): number | null {
        return this.organizationId;
    }
    get loggedOrganizationName(): string | null {
        return this.organizationName;
    }
}
